<template>
<div class="menucate-cls">
  <div class="rmvecls" :id="'menucateID-'+menu.id" @click="getActiveMenuId(menu.id)" v-if="$route.name == 'vendor' || $route.name == 'restaurant-details'">
    <img :src="menu.image" class="menu-cat-img"  @error="(e) => e.target.src = require('@/assets/images/no-img.png')">
    <h4>{{menu.name}}</h4>
  </div>
  <div v-if="pagename == 'home'" class="resturant-item busines-img-box">
    <div class="busines-img">
      <div class="img-box">
        <img :src="menu.image" @error="imageErrorHandle" alt="menu image">
      </div>
      <div class="resturant-data ml-3">
          <h4 :style="{ color: $auth?.setting?.web_settings?.text_primary_color+'!important' }">{{menu.name ?? menu.menu_name}}</h4>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import {imageErrorHandle} from '../helper/helper.js';

export default {
  props : ["menu","pagename"],
  data() {
    return {
      imageErrorHandle:imageErrorHandle,
      loading: true,
    };
  },
  methods: {
    getActiveMenuId(id){
      let element = document.getElementById('menucateID-'+id);
      $(".rmvecls").removeClass("active");
      element.className += " active";
      this.$emit("setCategoryMenuId",id);
    }
  }
}
</script>